import { Box, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';

type FieldBoxProps = {
  title?: string;
  children: ReactNode;
};

const FieldBox: FC<FieldBoxProps> = ({ title, children }) => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {title && (
        <Typography variant="body1" fontWeight={600} color="var(--base-black)">
          {title}
        </Typography>
      )}
      <Box
        display="flex"
        flexDirection="column"
        border="1px solid var(--neutral-500)"
      >
        {children}
      </Box>
    </Box>
  );
};

export default FieldBox;
